import { FC } from 'react'

import useGetCurrentProductName from 'src/hooks/useGetCurrentProductName'
import useProductMatchParams from 'src/hooks/useProductMatchParams'
import ComponentColor from 'src/types/ItemColor'
import PageHeaderTitle from '../../features/PageHeader/PageHeaderTitle'

export interface ProductPageProps {
  title?: string
}

const ProductPage: FC<ProductPageProps> = ({ title }) => {
  const routeParams = useProductMatchParams()

  const { product: productFormPathname } = routeParams?.params || {}

  const element = useGetCurrentProductName()

  const subProductName = element?.name || title || productFormPathname || ''

  const hasParentName = Boolean(element?.parentName)

  const productTitle = element?.parentName || subProductName

  return (
    <PageHeaderTitle
      title={productTitle}
      subTitle={hasParentName ? subProductName : ''}
      componentColor={ComponentColor.blue}
      dataPendo="product-page-header"
    />
  )
}

export default ProductPage
